/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Badge from '@mui/material/Badge';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useRecoilValue } from 'recoil';
import { projectsDataAtom, userDataAtom, mobileAtom } from '../Atoms';

const useStyles = makeStyles(() => ({
  child: {
    paddingLeft: 0,
    marginLeft: 0,
    paddingRight: 0,
  },
  account: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  item: {
    marginTop: '10vh',
  },
}));

const AccountSidebar = function ({ handleFilters, closeCounter, openCounter, handleReset }) {
  const classes = useStyles();
  const intl = useIntl();
  const userData = useRecoilValue(userDataAtom);
  const projectsData = useRecoilValue(projectsDataAtom);
  const mobile = useRecoilValue(mobileAtom);
  /**Filters declaration**/
  const [name, setName] = useState(null);
  const [pm, setPm] = useState(null);
  const [client, setClient] = useState(null);
  const [type, setType] = useState(null);

  /**Disables filters function **/
  const resetFilters = () => {
    setName(null);
    setPm(null);
    setClient(null);
    setType(null);
  };
  const getRoleName = (roleId) => {
    if (roleId === 0) return intl.messages.ADMIN;
    if (roleId === 1) return intl.messages.PROGRAMMANAGER;
    if (roleId === 2) return intl.messages.PROJECTMANAGER;
    if (roleId === 3) return intl.messages.MONITOR;
    return intl.messages.READER;
  };

  return (
    <Container
      className={classes.item}
      disableGutters
      sx={{ paddingLeft: mobile ? '1vw' : '.5vw', paddingRight: mobile ? '1vw' : '.5vw' }}
    >
      <Container className={classes.account} sx={{ mb: 1 }}>
        <Avatar className={classes.av} sx={{ width: 60, height: 60, backgroundColor: '#00796b' }}>
          {userData?.cognome?.substring(0, 1)}
        </Avatar>
        <Typography variant="subtitle2">
          {intl.messages.ROLE}: {getRoleName(userData?.ruolo)}
        </Typography>
        {userData === null ? (
          <CircularProgress color="primary" />
        ) : (
          <Typography variant="h6">{`${userData.nome} ${userData.cognome}`}</Typography>
        )}
      </Container>
      <Divider />
      <Container className={classes.child} sx={{ mt: 1, mb: 1 }}>
        <Typography variant="subtitle2">{intl.messages.PROJECTS?.toUpperCase()}</Typography>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Badge badgeContent={openCounter} color="primary" sx={{ mr: '1%' }}>
            <Chip label={intl.messages.OPEN} variant="outlined" />
          </Badge>
          <Badge badgeContent={closeCounter} color="primary" sx={{ ml: '1%' }}>
            <Chip label={intl.messages.CLOSED} />
          </Badge>
        </div>
      </Container>
      <Container className={classes.child} sx={{ mt: 3, mb: 1 }}>
        <Typography variant="subtitle2">{intl.messages.FILTER?.toUpperCase()}</Typography>
        <FormControl variant="filled" sx={{ m: 1, ml: 0, width: '100%' }}>
          <TextField
            label={intl.messages.PJNAME}
            variant="filled"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </FormControl>
        <FormControl variant="filled" sx={{ m: 1, ml: 0, width: '100%' }}>
          <InputLabel id="selectLabel">{intl.messages.PROJECTMANAGER}</InputLabel>
          <Select
            id="pm"
            onChange={(e) => {
              setPm(e.target.value);
            }}
            value={pm}
          >
            <MenuItem value={null}>
              <em>---</em>
            </MenuItem>
            {projectsData
              .reduce((acc, cur) => (acc.find((x) => x.Pm === cur.Pm) ? [...acc] : [...acc, { ...cur }]), [])
              .map((pj) => {
                return pj.isCurrent === 1 ? (
                  <MenuItem value={pj.Pm} key={pj.Pm}>
                    {pj.Pm}
                  </MenuItem>
                ) : null;
              })}
          </Select>
        </FormControl>
        <FormControl variant="filled" sx={{ m: 1, ml: 0, width: '100%' }}>
          <InputLabel id="selectLabel">{intl.messages.CLIENT}</InputLabel>
          <Select
            id="client"
            onChange={(e) => {
              setClient(e.target.value);
            }}
            value={client}
          >
            <MenuItem value={null}>
              <em>---</em>
            </MenuItem>
            {projectsData
              .reduce((acc, cur) => (acc.find((x) => x.Client === cur.Client) ? [...acc] : [...acc, { ...cur }]), [])
              .map((pj) => {
                return pj.isCurrent === 1 ? (
                  <MenuItem value={pj.Client} key={pj.Client}>
                    {pj.Client}
                  </MenuItem>
                ) : null;
              })}
          </Select>
        </FormControl>
        <FormControl variant="filled" sx={{ m: 1, ml: 0, width: '100%' }}>
          <InputLabel id="selectLabel">{intl.messages.STATUS}</InputLabel>
          <Select
            id="type"
            onChange={(e) => {
              setType(e.target.value);
            }}
            value={type}
          >
            <MenuItem value={null}>
              <em>---</em>
            </MenuItem>
            <MenuItem value="open">{intl.messages.OPEN}</MenuItem>
            <MenuItem value="close">{intl.messages.CLOSE}</MenuItem>
          </Select>
        </FormControl>
        <div>
          <Button
            variant="contained"
            startIcon={<FilterAltOutlinedIcon />}
            color="grey"
            size="small"
            onClick={() => {
              handleFilters([name, pm, client, type]);
            }}
            disabled={!(name || pm || client || type)}
          >
            {intl.messages.APPLYFILTERS}
          </Button>
          <Button
            varian="text"
            size="small"
            color="black"
            onClick={() => {
              resetFilters();
              handleReset();
            }}
          >
            reset
          </Button>
        </div>
      </Container>
    </Container>
  );
};

export default AccountSidebar;
